import './kitStyles';
import React from 'react';
import { Icon } from './Icon';
import type { IconName } from './icons';
import { Tip } from './Tip';

/**
 * WEB-3310 юнит 2а-1 — «?» с пояснением рядом с подписью, эталон `Help({ tip,
 * icon = 'help' })`: значок 14 в `Tip`, в порядке Tab, для диктора — картинка с
 * именем-пояснением (пояснение механики живёт здесь, а не текстом на экране, Т-3).
 */
export interface HelpProps {
  tip: string;
  icon?: IconName;
}

export function Help({ tip, icon = 'help' }: HelpProps): React.ReactElement {
  return (
    <Tip tip={tip} className="help" tabIndex={0} aria-label={tip} role="img">
      <Icon name={icon} size={14} />
    </Tip>
  );
}
